import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 粉丝自销页面路由
var TengjingShowHome = function TengjingShowHome() {
  return import('@/pages/tengjing/tengjing.vue');
};
export default [{
  //  tj ==> tengjing 腾竞APP 演出内嵌
  path: '/tj',
  component: TengjingShowHome,
  children: [{
    // 演出授权页
    path: 'auth*',
    name: 'tengjingAuth',
    component: function component() {
      return import('@/pages/tengjing/auth/auth.vue');
    }
  }, {
    // 演出列表
    path: 'list',
    name: 'tengjingList',
    component: function component() {
      return import('@/pages/tengjing/list/list.vue');
    }
  }]
}];